<template>
  <div>
    <div class="container md-block mt-4">
      <div class="content-filters px-4 pt-4 pb-3 my-4">
        <form ref="form-filter" v-on:submit.prevent="filterEnterprises">
          <div class="row"> <!-- begin::row-content-search -->
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <div class="form-group">
                <div class="content-filter-buttons">
                  <div class="group-filter-btn">
                    <label for="type-apartaments" :class="[form.tipo == 'apartamento' ? 'label checked' : 'label']" @click="filterByApartaments">Apartamentos</label>
                    <input type="radio" v-model="form.tipo" name="tipo" id="type-apartaments" value="apartamento" checked />
                  </div>
                  <div class="group-filter-btn">
                    <label for="type-houses" :class="[form.tipo == 'casa' ? 'label checked' : 'label']" @click="filterByhouses">Casas</label>
                    <input type="radio" v-model="form.tipo" name="tipo" id="type-houses" value="casa" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12">
              <div class="form-group">
                <select name="uf" v-model="form.uf" id="#" class="form-control">
                  <option :value="0" selected>Estados</option>
                  <option :key="uf.codigo" :value="uf.codigo" v-for="uf in states">{{ uf.descricao }}</option>
                  <!-- <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="DF">Distrito Federal</option>
                  <option value="ES">Espirito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option> -->
                </select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-5 col-sm-6 col-6">
              <div class="form-group">
                <select name="cidade" v-model="form.cidade" id="#" class="form-control">
                  <option :value="0" selected>Cidades</option>
                  <option :key="cidade.codigo" :value="cidade.codigo" v-for="cidade in cities">{{ cidade.descricao }}</option>
                </select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6">
              <div class="form-group">
                <select name="fase" v-model="form.fase" class="form-control">
                    <option :value="0" selected>Fases</option>
                    <option value="lancamento">Lançamento</option>
                    <option value="em-construcao">Em obra</option>
                    <option value="pronto">Pronto</option>
                </select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 text-right">
              <div class="btn-group w-100" role="group" aria-label="Basic example">
                <button type="submit" class="btn btn-custom w-100">Buscar</button>
              </div>
            </div>
          </div> <!-- end::row-content-search -->

          <!--<div class="row"> begin::row-content-btn-advanced-search -->
            <!-- <div class="col-md-3 ml-auto"> -->
              <!-- <small class="btn-advanced-search" @click="advancedSearch = !advancedSearch"> -->
                <!-- Busca avançada<i class="material-icons" v-bind:class="[advancedSearch ? 'animation-arrow' : '']" id="arrow-filter">expand_more</i> -->
              <!-- </small> -->
            <!-- </div> -->
          <!-- </div> end::row-content-btn-advanced-search -->

          <transition name="slide">
            <div class="row" v-if="advancedSearch"> <!-- begin::row-content-advanced-search -->
              <div class="col-xl-1 col-lg-1 col-md-1 col-sm-6 col-6">
                <div class="form-group">
                  <label for="dorms" class="label">Dorms.</label>
                  <select name="qtdDormitorios" id="dorms" v-model="advancedForm.qtdDormitorios" class="form-control">
                    <option :value="0" selected>...</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5+</option>
                  </select>
                </div>
              </div>
              <div class="col-xl-1 col-lg-1 col-md-1 col-sm-6 col-6">
                <div class="form-group">
                  <label for="suites" class="label">Suítes</label>
                  <select name="qtdSuites" id="suites" v-model="advancedForm.qtdSuites" class="form-control">
                    <option :value="0" selected>...</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4+</option>
                  </select>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                <div class="form-group">
                  <label for="faixaDePreco" class="label">Faixa de preço</label>
                  <select name="faixaDePreco" id="faixaDePreco" v-model="advancedForm.faixaDePreco" class="form-control">
                    <optgroup label="Para apartamentos" v-if="form.tipo == 'apartamento'">
                      <option value="0-280000" selected>Até 280 mil</option>
                      <option value="280000-450000">280 mil a 450 mil</option>
                      <option value="450000-600000">450 mil a 600 mil</option>
                      <option value="600000-750000">600 mil a 750 mil</option>
                      <option value="750000-0">Acima de 750 mil</option>
                    </optgroup>
                    <optgroup label="Para Casas" v-if="form.tipo == 'casa'">
                      <option value="0-100000" selected>Até 100 mil</option>
                      <option value="100000-250000">100 mil a 250 mil</option>
                      <option value="250000-400000">250 mil a 400 mil</option>
                      <option value="400000-600000">400 mil a 600 mil</option>
                      <option value="600000-0">Acima de 600 mil</option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-group mb-0">
                  <label class="label">Metragem: {{ sliderValues[0] }}m² - {{ sliderValues[1] }}m² <span v-if="sliderValues[1] == sliderMax">ou mais</span></label>
                  <ejs-slider
                    :min="sliderMin"
                    :max="sliderMax"
                    :value="sliderValues"
                    type="Range"
                    :tooltip="sliderRangeTooltip"
                    :limits="sliderRangeLimits"
                    :step="sliderStep"
                    name="metrosQuadrados"
                    v-on:tooltipChange="onSliderTooltipChange">
                  </ejs-slider>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 align-items-end d-flex h-69px">
                <button type="button" class="btn btn-secondary w-100 d-flex align-items-center justify-content-center btn-clear-filters mb-md-0 mb-sm-3 mb-3" @click="clearFields">
                  <i class="material-icons mr-1">close</i>
                  Limpar filtros
                </button>
              </div>
            </div> <!-- end::row-content-advanced-search -->
          </transition>
        </form>
      </div>
    </div>

    <div class="container" v-if="activeFilters.length > 1"> <!-- begin::active-filters -->
      <div class="row mb-5">
        <div class="col-12">
          <h4 class="title-content-active-tag-filters">Filtros usados:</h4>
          <ul class="active-filters-list pl-4 pt-4 d-flex flex-wrap">
            <TagActiveFilter @clicked="onTagClicked" v-for="tagFilter in activeFilters" :key="tagFilter" :name="tagFilter" />
          </ul>
        </div>
      </div>
    </div> <!-- end::active-filters -->

    <Cards :cards="activeEnterprises" :loading="loading" /> <!-- render cards -->

  </div>
</template>

<script>

import Vue from 'vue'
import TagActiveFilter from './TagActiveFilter.vue'
import Cards from './Cards.vue'
import { SliderPlugin } from "@syncfusion/ej2-vue-inputs"
import axios from 'axios'
import lodash from 'lodash'
import EventBus from '@/event-bus'

Vue.use(SliderPlugin)

export default {
  name: 'filters',
  data: function () {
    return {
      activeFilters: [],
      advancedSearch: false,
      sliderStep: 10,
      sliderMin: 0,
      sliderMax: 200,
      sliderRangeLimits: { enabled: true, minStart: 0, minEnd: 190, maxStart: 10, maxEnd: 200 },
      sliderRangeTooltip: { isVisible: true, placement: 'Before', showOn: 'Focus' },
      sliderValues: [0, 200],
      loading: true,
      enterprises: [],
      activeEnterprises: [],
      states: [],
      cities: [],
      form: {
        tipo: 'apartamento',
        uf: 0,
        cidade: 0,
        fase: 0,
      },
      advancedForm: {
        qtdDormitorios: 0,
        qtdSuites: 0,
        faixaDePreco: '0-280000',
        metrosQuadrados: '0,200',
      }
    }
  },

  created() {
    window.addEventListener("popstate", this.onLoadAndChangePopState)
  },

  async mounted() {

    await this.callAPI()

    if (_.size(this.$route.query) >= 1) {

      this.onLoadAndChangePopState()

    }

  },

  watch: {
    'advancedForm.metrosQuadrados': function (value) {
      this.sliderValues = value.split(',')
    }
  },

  methods: {

    onLoadAndChangePopState() {

      var uriParams = this.validateEntries(Object.entries(this.$route.query))

      if (uriParams.length >= 1) {

        var isAdvancedSearch = false

        var tmpForm = {
          tipo: uriParams[0][1] == 'apartamento' ? 'apartamento' : 'casa',
          uf: 0,
          cidade: 0,
          fase: 0,
        }
        var tmpAdvancedForm = {
          qtdDormitorios: 0,
          qtdSuites: 0,
          faixaDePreco: uriParams[0][1] == 'apartamento' ? '0-280000' : '0-100000',
          metrosQuadrados: uriParams[0][1] == 'apartamento' ? '0,200' : '250,1000',
        }

        uriParams.filter(function (uriKeyValue) {

          if (typeof tmpForm[uriKeyValue[0]] != 'undefined') {

            tmpForm[uriKeyValue[0]] = uriKeyValue[1]

          } else if (typeof tmpAdvancedForm[uriKeyValue[0]] != 'undefined') {

            tmpAdvancedForm[uriKeyValue[0]] = uriKeyValue[1]
            isAdvancedSearch = true

          }

        })

        this.advancedSearch = (isAdvancedSearch) ? true : false // toggle advanced search
        this.form = tmpForm
        this.advancedForm = tmpAdvancedForm

        this.filterEnterprises(false)

      } else {

        this.advancedSearch = false
        this.clearFields()
        this.filterEnterprises(false, true)

      }

    },

    async callAPI() {

      const token = await this.generateAccessToken()

      if (token) {

        const headers = this.generateHeaders(token)

        this.enterprises = this.activeEnterprises = await this.getEnterprises(headers) || []

        setTimeout(() => {
          this.loading = false
        }, 500)

      }

    },

    generateAccessToken() {

      let token = axios
      .request({ // Request token

        url: Vue.pathToken,
        method: "post",
        baseURL: Vue.baseURL,
        auth: {
          username: Vue.clientId,
          password: Vue.clientSecret
        },
        data: {
          "grant_type": "client_credentials"
        }

      }).then(response => {

        if (response.status == 200) {

          return response.data.access_token

        } else {

          this.$router.push('/manutencao')

        }

      }).catch(() => {

        this.$router.push('/manutencao')

        return;

      })

      return token

    },

    generateHeaders(token) {

      const headers = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded'
      }

      return headers

    },

    getEnterprises(headers) {

      let enterprises = axios
      .request({

        method: 'post',
        url: Vue.pathEnterprises,
        baseURL: Vue.baseURL,
        headers: headers

      }).then(response => {

        if (response.status == 200) {

          this.states = response.data.resultado.uf;
          this.cities = response.data.resultado.cidade;
          return response.data.resultado.empreendimentos;

        } else {

          this.$router.push('/manutencao')

        }

      })
      .catch(() => {

        this.$router.push('/manutencao')

      })

      return enterprises

    },

    filterEnterprises(saveHistory = true, defaultRoute = false) {

      this.loading = true
      EventBus.$emit('noEnterprisesFound', false)

      let filterParams = this.advancedSearch ?  _.pickBy(Object.assign({}, this.form, this.advancedForm), _.identity) : _.pickBy(this.form, _.identity)
      let serializeParams = !defaultRoute ? this.serializeDataToURL(filterParams) : '/'

      if (defaultRoute) filterParams = {}

      if (saveHistory && !_.isEqual(history.state, filterParams)) {

        history.pushState(filterParams, '', serializeParams)

      }

      const filteredEnterprises = this.enterprises.filter(enterprise => {

        let validEnterprise = true

        for (const param in filterParams) {

          let validParam = true

          switch (param) {

            case 'faixaDePreco': validParam = this.priceRangeFilter(enterprise.valorMin.codigo, enterprise.valorMax.codigo, filterParams[param], '-');
              break;

            case 'metrosQuadrados': validParam = this.rangeFilter(enterprise.metragem.codigo, filterParams[param], ',');
              break;

            case 'qtdDormitorios': validParam = this.breakpointFilter(enterprise[param].codigo, filterParams[param], 5);
              break;

            case 'qtdSuites': validParam = this.breakpointFilter(enterprise[param].codigo, filterParams[param], 4);
              break;

            default: validParam = this.directFilter(enterprise[param], filterParams[param]);

          }

          if (!validParam) {

            validEnterprise = false;
            break;

          }

        }

        return validEnterprise

      })

      this.activeFilters = _.keys(filterParams)
      this.activeEnterprises = filteredEnterprises

      EventBus.$emit('noEnterprisesFound', _.isEmpty(this.activeEnterprises) ? true : false)

      setTimeout(() => {
        this.loading = false
      }, 500)

    },

    directFilter(paramValue, filterValue) {

      if (typeof paramValue['codigo'] != 'undefined') {

        return paramValue.codigo == filterValue ? true : false;

      } else {

        return paramValue == filterValue ? true : false;

      }

    },

    priceRangeFilter(enterpriseMinValue, enterpriseMaxValue, stringRange, delimiter) {

      const range = stringRange.split(`${delimiter}`)
      let validPriceRange = false

      if (range[1] != 0) {

        if (
              (
                (range[0] == enterpriseMinValue) || (range[0] == enterpriseMaxValue) ||
                (range[1] == enterpriseMinValue) || (range[1] == enterpriseMaxValue)
              ) || // Quaisquer valores são exatamente iguais
              (_.inRange(enterpriseMinValue, range[0], range[1])) || // minEnterprise entre o range
              (_.inRange(enterpriseMaxValue, range[0], range[1])) || // maxEnterprise entre o range
              (_.inRange(range[0], enterpriseMinValue, enterpriseMaxValue)) || // minRange entre enterprise
              (_.inRange(range[1], enterpriseMinValue, enterpriseMaxValue)) // maxRange entre enterprise
        ) {

          validPriceRange = true

        }

      } else if (enterpriseMinValue >= range[0] || enterpriseMaxValue >= range[0]) {

        validPriceRange = true

      }

      return validPriceRange

    },

    rangeFilter(valuesArray, stringRange, delimiter) {

      const exceptionPoints = [0, 200, 1000]
      const range = stringRange.split(`${delimiter}`).map(Number)

      if (_.indexOf(exceptionPoints, range[1]) >= 0) {

        return (_.max(valuesArray) >= range[0]) ? true : false;

      } else {

        if ((_.indexOf(valuesArray, range[0]) >= 0) || (_.indexOf(valuesArray, range[1]) >= 0)) {

          return true;

        } else {

          for (const enterpriseValue of valuesArray) {

            if (_.inRange(enterpriseValue, range[0], range[1])) {

              return true;

            }

          }

          return false;

        }

      }

    },

    breakpointFilter(valueOfParam, valueOfFilter, exceptionMinValue) {

      if (valueOfFilter < exceptionMinValue) {

        return _.indexOf(valueOfParam, valueOfFilter) >= 0  ? true : false;

      } else {

        return valueOfParam >= valueOfFilter ? true : false;

      }

    },

    validateEntries(entries = Array) {

      if (Array.isArray(entries) && entries.length >= 1) { // There must be at least the enterprise parameter

        var enterpriseArray = entries.shift() // Get first param of query string to check if is valid enterprise

        if (enterpriseArray.length == 2) {

          var enterprise = ['apartamento', 'casa'].indexOf(enterpriseArray[1]) >= 0 ? enterpriseArray[1] : false

          if (enterprise) {

            if (enterprise == 'apartamento') {

              this.filterByApartaments()

            } else {

              this.filterByhouses()

            }

            var validEntries = []
            var whiteListOfEntries = {
              // uf: [0, 'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MS',
              //   'MT', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
              uf: _.keys(_.groupBy(this.states, 'codigo')),
              cidade: _.keys(_.groupBy(this.cities, 'codigo')),
              fase: ['lancamento', 'em-construcao', 'pronto'],
              qtdDormitorios: ['1', '2', '3', '4', '5'],
              qtdSuites: ['1', '2', '3', '4'],
              faixaDePreco: {
                apartamento: ['0-280000', '280000-450000', '450000-600000', '600000-750000', '750000-0'],
                casa: ['0-100000', '100000-250000', '250000-400000', '400000-600000', '600000-0']
              },
              metrosQuadrados: function(range) { // entry rules for square meters

                var rangeArray = range.split(',') // require two values

                if (rangeArray.length === 2) {

                  let minSliderValue = parseInt(rangeArray[0])
                  let maxSliderValue = parseInt(rangeArray[1])
                  let minStart = enterprise == 'apartamento' ? 0 : 250
                  let minEnd = enterprise == 'apartamento' ? 190 : 950
                  let maxStart = enterprise == 'apartamento' ? 10 : 300
                  let maxEnd = enterprise == 'apartamento' ? 200 : 1000
                  let step = enterprise == 'apartamento' ? 10 : 50

                  if ((minSliderValue >= minStart) && (minSliderValue <= minEnd) && (minSliderValue % step == 0 || minSliderValue == 0) && (maxSliderValue >= maxStart) && (maxSliderValue <= maxEnd) && (maxSliderValue % step == 0)) return true

                }

                return false

              }

            }

            entries.forEach(function (item) {

              if (Object.keys(whiteListOfEntries).indexOf(item[0]) != -1) {

                var paramIsValid = true

                switch (item[0]) {
                  case 'faixaDePreco': paramIsValid = whiteListOfEntries.faixaDePreco[enterprise].indexOf(item[1]) != -1 ? true : false
                    break;
                  case 'metrosQuadrados': paramIsValid = whiteListOfEntries.metrosQuadrados(item[1])
                    break;
                  default: paramIsValid = whiteListOfEntries[item[0]].indexOf(item[1]) != -1 ? true : false
                }

                if (paramIsValid) validEntries.push(item)

              }

            })

            validEntries.unshift(enterpriseArray)

            return validEntries

          }

        }

      }

      return false

    },

    filterByApartaments() {

      this.sliderStep = 10
      this.sliderMin = 0
      this.sliderMax = 200
      this.sliderRangeLimits = { enabled: true, minStart: 0, minEnd: 190, maxStart: 10, maxEnd: 200 }
      this.sliderValues = [0, 200]
      this.advancedForm.faixaDePreco = '0-280000'
      this.advancedForm.metrosQuadrados = '0,200'

    },

    filterByhouses() {

      this.sliderStep = 50
      this.sliderMin = 250
      this.sliderMax = 1000
      this.sliderRangeLimits = { enabled: true, minStart: 250, minEnd: 950, maxStart: 300, maxEnd: 1000 }
      this.sliderValues = [250, 1000]
      this.advancedForm.faixaDePreco = '0-100000'
      this.advancedForm.metrosQuadrados = '250,1000'

    },

    onSliderTooltipChange(args) {
      this.advancedForm.metrosQuadrados = args.value.join(',')
    },

    clearFields() {

      this.form = {
        tipo: 'apartamento',
        uf: 0,
        cidade: 0,
        fase: 0,
      }
      this.advancedForm = {
        qtdDormitorios: 0,
        qtdSuites: 0,
        faixaDePreco: '0-280000',
        metrosQuadrados: '0,200',
      }

      this.filterByApartaments()
      this.advancedSearch = false
      this.filterEnterprises(true, true)

    },

    onTagClicked(field) {

      if (typeof this.form[field] !== 'undefined') {

        this.form[field] = 0

      } else {

        this.advancedForm[field] = 0

      }

      this.filterEnterprises()

    },

    serializeDataToURL(obj) {

      let serialize = [];

      for (let param in obj) {
        if (obj.hasOwnProperty(param)) {
          serialize.push(encodeURIComponent(param) + "=" + encodeURIComponent(obj[param]))
        }
      }

      return location.protocol + "//" + location.host + "?" + serialize.join("&")

    }

  },
  components: {
    Cards,
    TagActiveFilter
  }
}
</script>

<style>
  /* begin::imports */
  @import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-popups/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
  /* end::imports */

  /* begin::slider */
  .e-range, .e-handle {
    background-color: #0d7658 !important;
  }
  .e-slider-tooltip.e-tooltip-wrap.e-popup {
    background-color: #0d7658;
  }
  .e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-inner {
    color: #0d7658;
  }
  .e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-outer.e-tip-bottom {
    border-top-color: #0d7658;
  }
  .e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-outer.e-tip-top {
    border-bottom-color: #0d7658;
  }
  .e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-outer.e-tip-right {
    border-left-color: #0d7658;
  }
  .e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-outer.e-tip-left {
    border-right-color: #0d7658;
  }
  /* end::slider */
</style>

<style scoped>
  /* begin::reset */
  input:focus,
  input:checked,
  select:focus,
  select:checked {
    outline: 0;
    box-shadow: none;
    border-color: #0d7658;
  }
  option:hover {
    background: #0d7658;
    color: #FFFFFF;
  }
  button {
    font-size: 14px;
    height: 38px;
  }
  .form-control {
    padding: 6px 6px;
  }
  /* end::reset */

  /* begin::animations */
  #arrow-filter {
    transition: all .5s ease;
  }
  .animation-arrow {
    transform: rotate(-180deg);
  }

  .slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }
  .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }
  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }
  @media (max-width: 767px) {
    .slide-enter-to, .slide-leave {
      max-height: 320px;
    }
  }
  .slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
  }
  /* end::animations */

  /* begin::custom */
  @media (min-width: 992px) {
    .form-group {
      margin-bottom: 0px !important;
    }
  }
  .label {
    font-size: 13px;
    font-weight: 500;
  }
  .content-filters {
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 2px 2px 20px rgba(0, 0, 0, .1);
  }

  .h-69px {
    height: 69px;
  }

  .btn-custom {
    background-color: #0d7658;
    color: #FFFFFF;
  }
    .btn-custom:hover {
      background-color: #000000;
      color: #FFFFFF;
    }

  .btn-advanced-search {
    cursor: pointer;
    line-height: 20px;
    font-size: 14px;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .content-filter-buttons {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #0d7658;
    color: #0d7658;
  }
    .group-filter-btn {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
      .group-filter-btn label {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        cursor: pointer;
        user-select: none;
        font-size: 14px;
      }
      .group-filter-btn label.checked {
        color: #FFFFFF;
        background: #0d7658;
      }
      .group-filter-btn input {
        position: absolute;
        opacity: 0;
        z-index: -1;
      }
  /* end::custom */

  /* begin::active-filters */
  .title-content-active-tag-filters {
    font-size: 16px;
    font-weight: 500;
  }
  .active-filters-list {
    background: #FFFFFF;
    border-radius: 12px;
    list-style: none;
    margin: 0px;
    display: flex;
    box-shadow: 2px 2px 20px rgba(0, 0, 0, .1);
  }
  /* end::active-filters */
</style>



// WEBPACK FOOTER //
// src/components/Filters.vue